import Surface from "@storeblocks/surface";
import { stbColors } from "Components/Themes/Storebrand/storebrandColors";
import styled from "styled-components";

export const CardLabel = styled.label`
  margin-right: auto;
`;

export const SelectedCard = styled(Surface)`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.brandColors.surface.border};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 8px;
  max-width: 375px;
  padding: ${({ theme }) => theme.spacing.sm};

  :hover {
    cursor: pointer;
  }

  &::before {
    background-color: ${({ theme }) =>
      theme.brandColors.selection?.background ??
      stbColors.selection.background};
    border: 5px solid
      ${({ theme }) =>
        theme.brandColors.selection?.main ?? stbColors.selection.main};
    border-radius: 50%;
    box-sizing: border-box;
    content: "";
    flex-shrink: 0;
    height: ${({ theme }) => theme.spacing.sm};
    margin-right: ${({ theme }) => theme.spacing.sm};
    margin-top: 5px;
    width: ${({ theme }) => theme.spacing.sm};
  }
`;

export const ResetButton = styled.a`
  margin-top: 24px;
`;
